jQuery(document).ready(function ($) {
  //RESPONSIVE TABLE
  const tableSelector = 'table.table-responsive';

  function normalizeText (value){
    return ( value || '' ).replace(/\s+/g, ' ').trim();
  }

  function hasContent ($cell){
    if (normalizeText($cell.text()).length) {
      return true;
    }

    return $cell.find('img, svg, video, audio, iframe, button, input, select, textarea').length > 0;
  }

  function getColumnLabels ($table){
    const $headerCells = $table.find('thead tr:last-child th');

    if (!$headerCells.length) {
      return [];
    }

    return $headerCells.map(function (){
      return normalizeText($(this).text());
    }).get();
  }

  function getBodyRows ($table){
    const $bodyRows = $table.find('tbody tr');

    if ($bodyRows.length) {
      return $bodyRows;
    }

    return $table.find('tr').filter(function (){
      return $(this).closest('thead').length === 0;
    });
  }

  function applyTwoColumnRowLabels ($row){
    const $cells = $row.children('td, th');

    if ($cells.length !== 2) {
      return false;
    }

    const title = normalizeText($cells.eq(0).text());

    if (!title) {
      return false;
    }

    $row.attr('data-card-title', title);
    $cells.eq(0).attr('data-card-cell-role', 'title');
    $cells.eq(1).attr('data-label', title);

    return true;
  }

  function enhanceTable (_, table){
    const $table = $(table);

    if ($table.attr('data-responsive-cards-ready') === 'true') {
      return;
    }

    const labels = getColumnLabels($table);
    const $rows = getBodyRows($table);
    const rowspans = [];

    $table.attr('data-responsive-cards-ready', 'true');
    $table.addClass('js-table-responsive-cards');

    $rows.each(function (){
      const $row = $(this);
      const $cells = $row.children('td, th');
      let visualColumnIndex = 0;
      let visibleCellIndex = 0;

      if (!labels.length && applyTwoColumnRowLabels($row)) {
        return;
      }

      $cells.each(function (){
        const $cell = $(this);

        while (rowspans[visualColumnIndex] && rowspans[visualColumnIndex].remaining > 0) {
          const inherited = rowspans[visualColumnIndex];

          if (!$row.attr('data-card-group') && inherited.text) {
            $row.attr('data-card-group', inherited.text);
          }

          inherited.remaining -= 1;

          if (inherited.remaining <= 0) {
            rowspans[visualColumnIndex] = null;
          }

          visualColumnIndex += 1;
        }

        const label = labels[visualColumnIndex] || '';
        const text = normalizeText($cell.text());
        const rowspan = parseInt($cell.attr('rowspan') || '1', 10);
        const isEmpty = !hasContent($cell);

        if (label) {
          $cell.attr('data-label', label);
        }

        $cell.toggleClass('is-empty', isEmpty);
        $cell.removeClass('is-odd is-even');

        if (!isEmpty) {
          $cell.addClass(visibleCellIndex % 2 === 0 ? 'is-odd' : 'is-even');
          visibleCellIndex += 1;
        }

        if (!$row.attr('data-card-title') && text) {
          $row.attr('data-card-title', text);
        }

        if (!$row.attr('data-card-group') && visualColumnIndex === 0 && text) {
          $row.attr('data-card-group', text);
        }

        if (rowspan > 1) {
          rowspans[visualColumnIndex] = {
            remaining: rowspan - 1,
            text: text
          };
        }

        visualColumnIndex += 1;
      });
    });
  }

  $(tableSelector).each(enhanceTable);
});
